import React from 'react';

import { EstatisticasListComp } from 'pages/estatisticas/components/pages/EstatisticasList';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';

export function EstatisticasList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['ESTATISTICA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <EstatisticasListComp />
        </ListagemProvider>
    );
}
